module.exports = __webpack_public_path__ + "static/media/circle_checkbox_default.86287022.svg";